import ErrorAlert from "@/utility/ErrorAlert";
import http from "../axios/http-common";

async function post(data) {
  const response = await http.postData("/partograf", data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response;
}

async function put(id, data) {
  const response = await http.putData(`/partograf/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response;
}

async function getById(id) {
  const response = await http.getData(`/partograf/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response;
}

async function getByReg(reg) {
  const response = await http.getData(`/register/${reg}/partograf`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data;
}

async function deleteObservasi(id, index) {
  const response = await http
    .deleteData(`/partograf/${id}/observasi/${index}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateCatatanPersalinan(id, data) {
  const response = await http
    .putData(`/partograf/${id}/catatan-persalinan`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function sign(id, password) {
  const response = await http
    .postData(`/partograf/${id}/sign`, { password })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

function print(id) {
  window.open(`${http.getAPI()}/partograf/${id}/pdf`, "_blank");
}

export default {
  post,
  put,
  getById,
  getByReg,
  deleteObservasi,
  updateCatatanPersalinan,
  sign,
  print
};
